import React, { useEffect, useState } from "react";
import {
  formPagoMercantil,
  optionAno,
  optionMes,
  optionPyment,
  optionPymentAllMercantil
} from "../../../../../propsType/Payemnts";
import { validatePagoMercantil } from "../../../../../validations/formValidations";
import { useForm } from "../../../../../Hooks/UseForm";
import PagosController from "../../../../../controllers/PagosController";
import SelectGeneric from "../../../../../components/Inputs/SelectGeneric";
import InputGeneric from "../../../../../components/Inputs/InputGeneric";
import ButtonGeneric from "../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../assets/png/bill.png";
import Spinner from "../../../../../components/Loading/loadingSpinner/Spinner";
import Modal from "../../../../../components/Modals/Modal";
import { useLocation } from "react-router-dom";
import moment from "moment";

function Mercantil({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
  bankInfo,
}) {
  const [stepsPayment, setStepsPayment] = useState(false);
  const [loading, setLoading] = useState(false);
  const { mercantilRegistro, mercantilPago } = PagosController();
  const [activeButton, setActiveButton] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [check, setCheck] = useState(false);
  const [message, setMessage] = useState("");
  const [actPass, setActPass] = useState(false);
  const location = useLocation();
  const [fechaNow, setFechaNow] = useState(moment().format("YYYY-MM-DD"));
  const [showNroTDC, setShowNroTDC] = useState(false);
  const [showCVV, setShowCVV] = useState(false);
  const [token, setToken] = useState("");
  const {
    form,
    errors,
    setForm,
    setErrors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm(formPagoMercantil, validatePagoMercantil, setActiveButton);
  const getToken = async () => {
    if (activeButton) {
      setErrors("");
      setActiveButton(false);
      setForm({
        ...form,
        numberCard: "",
        selectDoc: "",
        typeDoc: "",
        typeAccount: "",
        dateExpirationDay: "",
        dateExpirationMonth: "",
        name: "",
        code: "",
        keyPhone: "",
      });
      setActPass(false);
    }
    else {
      const result = handleSubmit();
      if (result === "ok") {
        setLoading(true);
        let newObjet =
        {
          nroTarjeta: form.numberCard,
          docIdentidad: form.selectDoc + form.typeDoc,
        };
        const res = await mercantilRegistro(newObjet);
        switch (res.codigo) {
          case "0":
            setLoading(false);
            setStepsPayment(true);
            setActiveModal(true);
            setCheck(true);
            setMessage(" Solicitud Exitosa. Por favor introduzca la clave temporal enviada a su teléfono.");
            setActPass(true);
            form.keyPhone.disabled = "false";
            break;
          default:
            setCheck(false);
            setLoading(false);
            setActiveModal(true);
            setMessage("Solicitud de Token no Exitosa.");
            setActiveButton(false);
            setActPass(false);
            break;
        }
      }
    }
  };

  const pagar = async () => {
    let result = null;
    result = handleSubmit();
    if (result === "ok") {
      setLoading(true);
      let typeAccount;
      if (form.typeAccount === "Corriente") { typeAccount = "CC"; }
      if (form.typeAccount === "Ahorro") { typeAccount = "CA"; }
      let newObjet = {
        nroTarjeta: form.numberCard,
        docIdentidad: form.selectDoc + form.typeDoc,
        tipoCuenta: typeAccount,
        otp: form.keyPhone,
        fechaExpiracion:
          form.dateExpirationMonth + "/" + form.dateExpirationDay,
        cvv: form.code,
        amount: data.metodoAPagar,
        nroCuenta: location.state.data.nroCuenta,
      };
      const res = await mercantilPago(newObjet);

      if (res.respuesta === "0") {
        setStapsState({
          ...stapsState,
          option1: false,
          option2: false,
          option3: false,
          option4: false,
          option5: true,
        });
        setData({
          ...data,
          transaccion: Math.round(Math.random() * 10000000000), montoTx: newObjet.amount, fecha: fechaNow
        });
        setActiveButton(true);
      }
      else {
        setLoading(false);
        setCheck(false);
        setActiveModal(true);
        setMessage(res?.error?.description || res?.descripcion);
        setErrors("");
        setActiveButton(false);
        setForm({
          ...form,
          numberCard: "",
          selectDoc: "",
          typeDoc: "",
          typeAccount: "",
          dateExpirationDay: "",
          dateExpirationMonth: "",
          name: "",
          code: "",
          keyPhone: "",
        });
        setActPass(false);
      }
    }
  };

  function filtro(e) {
    if (form.selectDoc !== "P"){
    var tecla = e.key;
    if (['.', 'e','E' ].includes(tecla))
      e.preventDefault()}
  }
  
  const closetModal = () => {
    setActiveModal(false);
    setMessage("");
    if (activeButton) { setErrors('') }
  };
  useEffect(() => {
    if (form.keyPhone.toString().length < 8)
      setActiveButton(false);
    else
      setActiveButton(true);
  })
  const funtionShowCVV = () => { setShowCVV(!showCVV); };
  const funtionShowNroTDC = () => { setShowNroTDC(!showNroTDC); };
  return (
    <>
      <div className="flex lg:pt-[125px] pt-[220px] flex-col-reverse px-5 pb-6 lg:flex-row lg:pb-7  lg:px-[28px] gap-4 relative">
        <div className="lg:w-[70%]  ">
          {loading ? (
            <>
              <div className="w-full h-full flex justify-center items-center">
                <Spinner title={"Solicitud en Proceso. Espere por favor..."} />
              </div>
            </>
          ) : (
            <>
              <div className="absolute left-0 top-0 w-full ">
                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                  <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-4">
                      <h3 className="text-2xl leading-6 font-medium text-gray-900">
                        Pagar
                      </h3>
                      <p className="mt-1 text-sm text-gray-500">
                        Completa la información y haz clic en pagar
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                <div className="grid lg:gap-[20px] gap-6 lg:relative lg:-top-[25px]">
                  <div className="flex justify-center flex-col lg:flex-row items-center gap-5">
                    <div className="w-full">
                      <InputGeneric
                        title={"Número de Tarjeta"}
                        name={"numberCard"}
                        value={form.numberCard}
                        errorText={errors.numberCard}
                        onChange={handleChange}
                        handleBlur={handleBlur}
                        disable={actPass}
                        //type={"number"}
                        type={showNroTDC ? "text" : "password"}
                        show={showNroTDC}
                        funtionShow={funtionShowNroTDC}
                        maxValue={18}
                      />
                    </div>

                    <div className="grid w-full">
                      <div className="text-sm font-medium text-gray-900">
                        Documento de Identidad
                      </div>
                      <div className="grid !mt-1  grid-cols-7">
                        <div className="col-span-2">
                          <SelectGeneric
                            onChange={handleChange}
                            value={form.selectDoc}
                            name={"selectDoc"}
                            onBlur={handleBlur}
                            errors={errors.selectDoc}
                            selectData={optionPyment}
                            disabled={actPass}
                          />
                        </div>
                        <div className="col-span-5">
                          <InputGeneric
                            name={"typeDoc"}
                            type={form?.selectDoc === "P" ? "text" : "number"}
                            onKeyDown={(e) => filtro(e)}
                            maxValue={13}
                            value={form.typeDoc}
                            onChange={handleChange}
                            handleBlur={handleBlur}
                            errorText={errors.typeDoc}
                            disable={actPass}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex justify-between gap-5">
                    <div className="grid w-full ">
                      <div className="text-sm font-medium text-gray-900">
                        Tipo de Cuenta
                      </div>
                      <div className="grid !mt-1 ">
                        <SelectGeneric
                          onChange={handleChange}
                          value={form.typeAccount}
                          name={"typeAccount"}
                          onBlur={handleBlur}
                          errors={errors.typeAccount}
                          selectData={optionPymentAllMercantil}
                          disabled={actPass}

                        />
                      </div>
                    </div>

                    <div className="w-full ">
                      <InputGeneric
                        title={"Nombre del Titular"}
                        name={"name"}
                        handleBlur={handleBlur}
                        onChange={handleBlur}
                        errorText={errors.name}
                        value={form.name}
                        disable={actPass}
                      />
                    </div>
                  </div>

                  <div className="w-full flex justify-between flex-col lg:flex-row items-center gap-5 ">
                    <div className="flex w-full flex-col gap-3">
                      <div className="flex gap-5 ">
                        <div className="grid w-full ">
                          <div className="text-sm font-medium text-gray-900">
                            Mes de Vencimiento
                          </div>
                          <div className="grid !mt-1 ">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.dateExpirationDay}
                              name={"dateExpirationDay"}
                              onBlur={handleBlur}
                              errors={errors.dateExpirationDay}
                              selectData={optionMes}
                              disabled={actPass}
                            />
                          </div>
                        </div>
                        <div className="grid w-full ">
                          <div className="text-sm font-medium text-gray-900">
                            Año de Vencimiento
                          </div>
                          <div className="grid !mt-1 ">
                            <SelectGeneric
                              onChange={handleChange}
                              value={form.dateExpirationMonth}
                              name={"dateExpirationMonth"}
                              onBlur={handleBlur}
                              errors={errors.dateExpirationMonth}
                              selectData={optionAno}
                              disabled={actPass}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full">
                      <InputGeneric
                        title={"Código de Seguridad (CVV)"}
                        name={"code"}
                        handleBlur={handleBlur}
                        onChange={handleBlur}
                        errorText={errors.code}
                        type={showCVV ? "text" : "password"}
                        show={showCVV}
                        funtionShow={funtionShowCVV}
                        value={form.code}
                        maxValue={3}
                        disable={actPass}
                      />
                    </div>
                  </div>

                  <div className="flex justify-between gap-5">
                    <div className="w-full">
                      <InputGeneric
                        title={"Clave Temporal"}
                        name={"keyPhone"}
                        handleBlur={handleBlur}
                        onChange={handleBlur}
                        errorText={errors.keyPhone}
                        value={form.keyPhone}
                        disable={!actPass}
                        maxValue={8}

                      />
                    </div>
                    <div className="col-span-5 flex h-full items-end w-full">
                      <button
                        type="button" disabled={activeButton}
                        onClick={() => getToken()}
                        className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto"
                      >
                        {activeButton ? "Solicitar" : "Solicitar"}
                      </button>
                    </div>
                  </div>
                  <p className="text-[0.8rem] text-[#798791]">
                    Importante: Por favor asegúrese de colocar los datos exactos de su tarjeta, para una transacción exitosa.
                  </p>
                  <hr />
                </div>
                <div className="w-full mt-5 flex justify-between items-center gap-[50%]">
                  <div className="w-full">
                    <ButtonGeneric funtion={back} text={"Volver"} />
                  </div>
                  <div className="w-full">
                    <ButtonGeneric
                      funtion={pagar}
                      text={"Pagar"}
                      disable={!activeButton}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="lg:w-[30%] relative sha">
          <div
            className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   
                            before:content-[''] 
                            before:absolute 
                            before:w-[45px] 
                            before:h-[45px] 
                            before:rounded-full 
                            before:bg-white 
                            before:bottom-[-20px]
                            before:left-[-20px]
                            after:content-[''] 
                            after:absolute 
                            after:w-[45px] 
                            after:h-[45px] 
                            after:rounded-full 
                            after:bg-white 
                            after:bottom-[-20px]
                            after:right-[-20px] 
            "
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")] bg-right w-[80%] bg-auto bg-no-repeat flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-25%] z-[10] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center items-center">
                <div className="w-[90%] object-contain">
                  <img
                    className="w-full object-contain "
                    src={bankInfo?.banco?.logo}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {bankInfo?.banco?.title}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] "> {
                  deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                    (
                      <>
                        Saldo a favor
                      </>
                    )
                    :
                    (
                      <>
                        Saldo
                      </>
                    )
                }</div>
                <div className="font-medium">Bs {deatils?.deudaTotalVEF}</div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
          </div>

          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div>
                  <div className="text-[#798791] ">Monto a Pagar</div>
                  <div className="text-2xl font-medium">
                    <span className="text-[#798791] pr-2 ">Bs</span>
                    {data?.metodoAPagar}
                  </div>
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bills} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        string={check ? "check" : "error"}
        message={message}
        active={activeModal}
        setActive={setActiveModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex  flex-col gap-2 ">
            <button
              type="button"
              onClick={closetModal}
              className={` ${check ? "bg-green-500" : "bg-red-500"
                } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
            >
              Aceptar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Mercantil;
